import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-zoomminus-icon',
  templateUrl: './design-zoomminus.component.html'
})
export class DesignZoomMinusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
